import React from 'react'

import QuantityChip from '@/components/pages/production/components/filters/filters-quantity/components/quantity-chip'

import styles from './styles.module.scss'

const FiltersQuantityChips = () => {
    return (
        <div className={styles.chipRowContainer}>
            <div className={styles.chipRow}>
                <QuantityChip label="1" quantity={1} />
                <QuantityChip label="2" quantity={2} />
                <QuantityChip label="3" quantity={3} />
                <QuantityChip label="4" quantity={4} />
            </div>
            <div className={styles.chipRow}>
                <QuantityChip label="5" quantity={5} />
                <QuantityChip label="6" quantity={6} />
                <QuantityChip label="7" quantity={7} />
                <QuantityChip label="8+" quantity={8} />
            </div>
        </div>
    )
}

export default FiltersQuantityChips
